<script lang="ts">
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  export let vintages: number | number[];

  const vintageArray = typeof vintages === "number" ? [vintages] : vintages;

  $: maxBadges = $LayoutStore.isMobile ? 5 : 7;
  $: hiddenBadgeCount = vintageArray.length - maxBadges;

</script>

<div class="fizz-flex-row-4" data-testid="product-card-vintages">
  {#each vintageArray.slice(0, maxBadges) as vintage}
    <div data-testid="product-card-vintage">
      <span class="fizz-badge-small" data-testid="product-card-vintage-{vintage}">
        {vintage}
      </span>
    </div>
  {/each}
  {#if hiddenBadgeCount > 0}
    <span class="fizz-text-subdued fizz-text-small" data-testid="product-card-vintages-overflow">
      +{hiddenBadgeCount}
    </span>
  {/if}
</div>
